import { Box, Card, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { Carousel } from "react-responsive-carousel";
import { BIBlue, BIGrey } from "../../assets/helpers";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import defaultProjectImage from "../../assets/images/image-unavailable.jpg";
import CloseIcon from "@mui/icons-material/Close";


export default function AdsCarousel({ adsData }) {
  const navigate = useNavigate();

  const { multiLanguageData } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.DashBoard || {};
  const { TEXT_WHATS_NEW = English.DashBoard.TEXT_WHATS_NEW } = LanguageData || {};

  const [activeSlide, setActiveSlide] = useState(0);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerItem, setViewerItem] = useState(null);

  const handleSlideChange = (index) => {
    setActiveSlide(index);
  };

  function handleAdClick(clickFrom) {
    switch (clickFrom) {
      case "tickets":
      case "Tickets":
        navigate("/tickets");
        break;
      case "MySites":
      case "MySites1":
      case "Sites":
      case "sites":
        navigate("/sites");
        break;
      case "Quiz":
        navigate("/reward-store/earn-builderbucks/");
        // navigate("/reward-store/earn-builderbucks/earn-rewards/");
        break;
      case "Carpool":
        navigate("/carpool/");
        break;
      case "Expenses":
        navigate("/expenses");
        break;
      case "RewardStore":
        navigate("/reward-store/");
        break;
      case "https://mybuilderid.com/":
        window.open(clickFrom, "_blank");
        break;
      default:
        if (clickFrom) {
          const url =
            clickFrom.startsWith("http://") || clickFrom.startsWith("https://")
              ? clickFrom
              : `https://${clickFrom}`;
          window.open(url, "_blank");
        }
        break;
    }
  }

  return (
    <>
      <Card
        sx={{
          borderRadius: "20px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
          border: "1px solid #f1f5f9",
          overflow: "hidden",
          cursor: "pointer",
          transition: "transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.06)",
            borderColor: "#cbd5e1"
          }
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 3, pt: 2.5 }}>
          <Typography sx={{ fontWeight: "950", letterSpacing: "-0.5px", fontSize: "17px", color: "text.primary" }}>
            {TEXT_WHATS_NEW}
          </Typography>
          <Box
            sx={{
              backgroundColor: "#fdc003",
              color: "#000",
              fontWeight: "800",
              borderRadius: "6px",
              px: 1.2,
              py: 0.4,
              fontSize: "10px",
              textTransform: "uppercase",
              letterSpacing: "0.5px"
            }}
          >
            Updates
          </Box>
        </Box>
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Carousel
            showThumbs={false}
            showArrows={false}
            showIndicators={adsData?.length === 0 ? false : true}
            autoFocus={true}
            swipeable={true}
            emulateTouch={true}
            useKeyboardArrows={true}
            showStatus={false}
            infiniteLoop={true}
            dynamicHeight={false}
            autoPlay={true}
            interval={2500}
            width="100%"
            selectedItem={activeSlide}
            onChange={handleSlideChange}
            onClickItem={(index) => {
              const item = adsData?.[index];
              if (item) {
                handleAdClick(item?.redirectUrl || item?.link || item?.url);
              }
            }}
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              const style = {
                width: "8px",
                height: "8px",
                margin: "0 5px",
                background: isSelected ? BIBlue : BIGrey,
                borderRadius: "50%",
                cursor: "pointer",
                display: "inline-block",
                textAlign: "center",
                marginTop: "10px"
              };
              return (
                <li
                  style={style}
                  onClick={onClickHandler}
                  onKeyDown={onClickHandler}
                  value={index}
                  key={index}
                  role="button"
                  tabIndex={0}
                  title={`${label} ${index + 1}`}
                />
              );
            }}>
            {adsData?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="taketour-image-section"
                  style={{ cursor: "pointer", display: "flex", flexDirection: "column", textAlign: "left" }}
                  onClick={() => handleAdClick(item?.redirectUrl || item?.link || item?.url)}>
                  {/* Image: click opens image viewer */}
                  <Box
                    sx={{
                      borderRadius: "14px",
                      overflow: "hidden",
                      height: "190px",
                      width: "100%",
                      cursor: "zoom-in",
                      bgcolor: (theme) => (theme.palette.mode === "dark" ? "rgba(255,255,255,0.03)" : "#f8fafc"),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid",
                      borderColor: (theme) => (theme.palette.mode === "dark" ? "rgba(255,255,255,0.06)" : "#f1f5f9")
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setViewerItem(item);
                      setViewerOpen(true);
                    }}>
                    <img
                      src={item?.fileUrl}
                      alt={`Ad ${index + 1}`}
                      onError={(e) => {
                        e.target.src = defaultProjectImage;
                      }}
                      style={{
                        objectFit: "contain",
                        maxHeight: "100%",
                        maxWidth: "100%",
                        width: "auto",
                        height: "auto",
                        display: "block"
                      }}
                    />
                  </Box>
                  <Box sx={{ p: 1.5, textAlign: "left", height: "65px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <Typography variant="subtitle2" fontWeight="800" sx={{ color: "text.primary", mb: 0.2 }} noWrap>
                      {item?.name || "New Feature Update"}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "text.secondary",
                        fontSize: "11px",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        lineHeight: "1.3"
                      }}>
                      {item?.description || "Learn more about our latest improvements and feature additions."}
                    </Typography>
                  </Box>
                </div>
              );
            })}
          </Carousel>
        </Box>
      </Card>

      {/* Image Viewer Dialog */}
      <Dialog
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden" } }}>
        <Box sx={{ position: "relative", bgcolor: "#f8fafc", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <IconButton
            onClick={() => setViewerOpen(false)}
            sx={{ position: "absolute", top: 8, right: 8, zIndex: 1, bgcolor: "rgba(0,0,0,0.4)", color: "white", "&:hover": { bgcolor: "rgba(0,0,0,0.6)" } }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <img
            src={viewerItem?.fileUrl || defaultProjectImage}
            alt={viewerItem?.name || "Feature"}
            onError={(e) => { e.target.src = defaultProjectImage; }}
            style={{ width: "100%", maxHeight: "400px", objectFit: "contain", display: "block" }}
          />
        </Box>
        {(viewerItem?.name || viewerItem?.description) && (
          <DialogContent sx={{ pt: 2, pb: 2.5 }}>
            {viewerItem?.name && (
              <Typography variant="h6" fontWeight="800" sx={{ mb: 0.5, letterSpacing: "-0.3px" }}>
                {viewerItem.name}
              </Typography>
            )}
            {viewerItem?.description && (
              <Typography variant="body2" sx={{ color: "text.secondary", lineHeight: 1.6 }}>
                {viewerItem.description}
              </Typography>
            )}
          </DialogContent>
        )}
      </Dialog>
    </>
  );
}
